import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCompactDateTimeRange(startDateStr: string | Date | null | undefined, endDateStr: string | Date | null | undefined) {
  if (!startDateStr && !endDateStr) return '';

  const start = startDateStr ? new Date(startDateStr) : null;
  const end = endDateStr ? new Date(endDateStr) : null;

  // Use active i18n language for month/day names
  const lang = (typeof window !== 'undefined' && (window as any).i18next?.language) || 'en-US';

  const monthDayYear: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  const monthDay: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  const time: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };

  if (start && end) {
    const sameYear = start.getFullYear() === end.getFullYear();
    const sameMonth = sameYear && start.getMonth() === end.getMonth();

    if (sameMonth) {
      // Sep 7–9, 2025, 4:50 PM
      const startMonthDay = start.toLocaleDateString(lang, monthDay);
      const endDay = end.getDate();
      const endTime = end.toLocaleTimeString(lang, time);
      return `${startMonthDay.replace(/\d+$/, String(start.getDate()))}–${endDay}, ${start.getFullYear()}, ${endTime}`;
    }

    // Cross month or cross year → Sep 27, 2025 → Oct 4, 2025, 4:50 PM
    const startFull = start.toLocaleDateString(lang, monthDayYear);
    const endFull = end.toLocaleDateString(lang, monthDayYear);
    const endTime = end.toLocaleTimeString(lang, time);
    return `${startFull} → ${endFull}, ${endTime}`;
  }

  if (start) {
    return start.toLocaleDateString(lang, monthDayYear);
  }
  if (end) {
    const endFull = end.toLocaleDateString(lang, monthDayYear);
    const endTime = end.toLocaleTimeString(lang, time);
    return `${endFull}, ${endTime}`;
  }
  return '';
}